// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"1797844a","247":"74d02e94","288":"07e3e8b0","422":"8dbc1a67","627":"ec07703b","653":"4136e9b7","768":"1870b7b9","834":"c597fbaa","842":"7328b3b8","867":"cd501c63","923":"29bdf011","938":"7a86cd4d"}[chunkId] + ".chunk.js";
};